/** Property code kinds, in the order the workbook sheets and every select list them. */
export const PROPCODE_KINDS = [
    { value: "investment", label: "Investment", sheet: "Investment_mapping" },
    { value: "entity", label: "Entity", sheet: "Entity_mapping" },
    { value: "asset", label: "Asset", sheet: "Asset_mapping" },
] as const;

/** The primary identifier: the kind a new mapping defaults to. */
export const DEFAULT_PROPCODE_KIND = "entity";

export const PROPCODE_SHEET_NAMES: string[] = PROPCODE_KINDS.map((k) => k.sheet);

export const PROPCODE_REQUIRED_COLUMNS = ["Third Entity Code", "Platform Entity Code"];

export const PROPCODE_UPLOAD_HINT = `Sheets: ${PROPCODE_SHEET_NAMES.join(", ")}; columns: ${PROPCODE_REQUIRED_COLUMNS.join(", ")}`;

export const propcodeKindLabel = (kind: string): string =>
    PROPCODE_KINDS.find((k) => k.value === kind)?.label ?? kind;
